export const DEFAULT_OFFSET = 8;
export const DEFAULT_PADDING = 8;
export const DEFAULT_POSITION = 'top';
export const DEFAULT_IS_SHADOW_VISIBLE = true;
export const DEFAULT_SHADOW = '0px 0px 8px 0px #00000029';
export const DEFAULT_BORDER_RADIUS = {
  topLeft: 8,
  topRight: 8,
  bottomLeft: 8,
  bottomRight: 8,
  measureUnit: '1px' as '1%'
};
export const DEFAULT_IS_BORDER_VISIBLE = true;
export const DEFAULT_BORDER = {
  borderColor: '#a6a7ab',
  borderWidth: 1,
  borderStyle: 'solid'
};

export const TOOLTIP_SHADOWS = ['0px 0px 8px 0px', '0px 4px 8px 0px', '0px -4px 8px 0px'];
export const TOOLTIP_POSITION = ['top', 'bottom', 'top-start', 'top-end', 'bottom-start', 'bottom-end'];
